/* =====================================================================
   Element Eight — inject subscription perks into the Seal widget
   ---------------------------------------------------------------------
   Adds a collapsible benefits panel inside the "Subscribe & Save" card on
   the product page: hidden by default, revealed by a "See Details" toggle
   (with an X to close). Seal renders/re-renders its widget with JavaScript,
   so we watch for it and (re)inject idempotently. Skips the one-time card.
   ===================================================================== */
(function () {
  var INTRO = 'Minimum commitment of 3 delivery cycles.';

  var PERKS = [
    'Save 20% on subscription orders.',
    'Free shipping on domestic (U.S) orders.',
    'Swap between products anytime and maintain discount.',
    'Flexibility to adjust order frequency.',
    'Easily cancel or pause, after a minimum of 3 delivery cycles.',
    { before: 'Earn loyalty points on every order – join ', link: { text: 'Oxygen Amplified Rewards', href: '/pages/2x-loyalty' }, after: '.' }
  ];

  function buildList() {
    var ul = document.createElement('ul');
    ul.className = 'ee-subscription-perks';
    PERKS.forEach(function (p) {
      var li = document.createElement('li');
      if (typeof p === 'string') {
        li.textContent = p;
      } else {
        if (p.before) li.appendChild(document.createTextNode(p.before));
        if (p.link) {
          var a = document.createElement('a');
          a.className = 'ee-perks-link';
          a.href = p.link.href;
          a.textContent = p.link.text;
          li.appendChild(a);
        }
        if (p.after) li.appendChild(document.createTextNode(p.after));
      }
      ul.appendChild(li);
    });
    return ul;
  }

  // The "See Details" toggle — sits next to the interval dropdown.
  function makeButton() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ee-see-details';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'See Details';
    btn.addEventListener('click', function () {
      var card = btn.closest('.sls-option-container');
      var wrap = card && card.querySelector('.ee-perks-wrap');
      if (!wrap) return;
      var open = !wrap.classList.contains('is-open');
      wrap.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    return btn;
  }

  // The collapsible perks panel — sits below, revealed by the toggle.
  function makePanel() {
    var wrap = document.createElement('div');
    wrap.className = 'ee-perks-wrap';

    var panel = document.createElement('div');
    panel.className = 'ee-perks-panel';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'ee-perks-close';
    close.setAttribute('aria-label', 'Close details');
    close.innerHTML = '&times;';
    close.addEventListener('click', function () {
      wrap.classList.remove('is-open');
      var card = wrap.closest('.sls-option-container');
      var btn = card && card.querySelector('.ee-see-details');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });

    panel.appendChild(close);
    if (INTRO) {
      var intro = document.createElement('p');
      intro.className = 'ee-perks-intro';
      intro.textContent = INTRO;
      panel.appendChild(intro);
    }
    panel.appendChild(buildList());
    wrap.appendChild(panel);
    return wrap;
  }

  function inject() {
    var cards = document.querySelectorAll(
      '.sls-purchase-options-container .sls-option-container'
    );
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      // skip the one-time purchase card
      if (card.querySelector('input[data-type="one_time"], .sls-one-time-price')) continue;

      var labelContainer = card.querySelector('.sls-label-container') || card;

      // Toggle — right-aligned on the interval row (under the price). Find the
      // interval row (the label-container child that holds the delivery
      // select), make it a flex row, and drop the toggle at its far right.
      if (!card.querySelector('.ee-see-details')) {
        var select = card.querySelector('.sls-select');
        var placed = false;
        if (select) {
          var row = select;
          while (row.parentElement && row.parentElement !== labelContainer) {
            row = row.parentElement;
          }
          if (row.parentElement === labelContainer && row !== select) {
            row.classList.add('ee-interval-row');
            row.appendChild(makeButton());
            placed = true;
          }
        }
        if (!placed) labelContainer.appendChild(makeButton());
      }

      // Panel — placed below in the label container.
      if (!card.querySelector('.ee-perks-wrap')) {
        labelContainer.appendChild(makePanel());
      }
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var run = function () { scheduled = false; inject(); };
    if (window.requestAnimationFrame) { window.requestAnimationFrame(run); }
    else { window.setTimeout(run, 16); }
  }

  function start() {
    inject();
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
